/**
	* MG Time Tracker Application
	*	DistributorSearchSelectList.js
	*/

import React, { Component } from 'react';
import { connect } from "react-redux";

// Component Imports
import SearchSelectList from '../SearchSelectList';
import SearchSelectListItem from '../SearchSelectListItem';

// SASS Imports
require('./DistributorSearchSelectList.scss');

let mapStateToProps = (store) => {
	return {
        api: store.api
	}
};


class DistributorSearchSelectList extends Component {
    constructor(props) {
        super(props);

        this.renderItem = this.renderItem.bind(this);
        this.onFetch = this.onFetch.bind(this);
    }
    onFetch(filterQuery, extraFilter, size, from) {
        return this.props.api.getDistributors({
            filterQuery,
            size,
            from
        }).then((response) => {
            return {
                results: response.distributors.map((d) => ({...d, getId:() => d.distributorId})),
                total:response.total
            };
        });
    }

    renderItem(distributor) {
        return (
            <SearchSelectListItem
                item={distributor}
                key={distributor.distributorId}
                rowClassName="distributorListItem"
                selectText="Select Distributor"
                onSelectItem={ this.props.onSelectItem }
                mainColSize={8}
            >
                <h5 className="distributorName">{ distributor.distributorName }</h5>
            </SearchSelectListItem>
        );
    }
    render() {
        return (
            <SearchSelectList
                title="Select Your Distributor"
                searchPlaceholder="Search to find a distributor"
                onFetch={this.onFetch}
                showStaticList={false}
                showFilter={false}
                renderItem={this.props.renderItem ? this.props.renderItem : this.renderItem}
                {...this.props}
            />
        );
    }
}

export default connect(mapStateToProps)(DistributorSearchSelectList);



// WEBPACK FOOTER //
// ./app/components/SelectLists/Types/DistributorSearchSelectList.jsx